import { render, staticRenderFns } from "./CommentsTableView.vue?vue&type=template&id=1da968cc&"
import script from "./CommentsTableView.vue?vue&type=script&lang=js&"
export * from "./CommentsTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports